// Common country names for the registration searchable selector (datalist).
export const COUNTRIES = [
  "Malaysia", "Singapore", "United States", "United Kingdom", "Australia", "Canada",
  "France", "Germany", "Spain", "Italy", "Netherlands", "Belgium", "Switzerland",
  "Ireland", "Portugal", "Sweden", "Norway", "Denmark", "Finland", "Austria",
  "Poland", "Greece", "Czech Republic", "Romania", "Hungary", "Luxembourg",
  "Indonesia", "Thailand", "Philippines", "Vietnam", "Brunei", "Cambodia", "Laos",
  "Myanmar", "India", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal",
  "China", "Hong Kong", "Taiwan", "Japan", "South Korea", "Mongolia",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman",
  "Israel", "Turkey", "Egypt", "South Africa", "Nigeria", "Kenya", "Ghana", "Morocco",
  "New Zealand", "Fiji",
  "Brazil", "Mexico", "Argentina", "Chile", "Colombia", "Peru", "Uruguay",
  "Russia", "Ukraine", "Kazakhstan",
  "Iceland", "Croatia", "Slovenia", "Slovakia", "Bulgaria", "Lithuania", "Latvia", "Estonia",
  "Other",
];
